module.exports = __webpack_public_path__ + "img/gpt3.82fba952.png";